var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    path: "#03f",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8773",
    "data-name": "Group 8773",
    transform: "translate(-314 -641)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 42,
    height: 42,
    rx: 21,
    transform: "translate(314 641)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6913",
    "data-name": "Group 6913",
    transform: "translate(325.844 653.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M194.87,382.249H179.125a1.125,1.125,0,1,1,0-2.249H194.87a1.125,1.125,0,0,1,0,2.249Zm0,0",
    transform: "translate(-178 -372.127)",
    fill: "#03f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M291.125,285.995A1.125,1.125,0,0,1,290,284.87V269.125a1.125,1.125,0,0,1,2.249,0V284.87a1.125,1.125,0,0,1-1.125,1.125Zm0,0",
    transform: "translate(-282.128 -268)",
    fill: "#03f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle+.8c0b7de3dbe705161c34f112bb2fb5c4.svg";
export { ForwardRef as ReactComponent };